import { LinkingOptions, getPathFromState } from '@react-navigation/native';

import { SCREEN } from 'router/screens';
import { RootPathnames } from 'router/types';

import getUrlFromScreenName from './getUrlFromScreenName';

const defaultConfig = {
    [SCREEN.SPLASH_SCREEN]: '',
    [SCREEN.PERSONALIZE_SCREEN]: 'personalize',
    [SCREEN.WELCOME_SCREEN]: 'welcome',
    [SCREEN.LANDING_SCREEN]: 'landing',
    [SCREEN.LOGIN_SCREEN]: 'login',
    [SCREEN.FTI_TUTORIAL]: 'tutorial',
    [SCREEN.PROFILES]: 'profiles',
    [SCREEN.PROFILE_TYPE]: 'profile-type',
    [SCREEN.ADD_PROFILE]: 'add-profile',
    [SCREEN.PROFILE_AGE_RATING]: 'profile-age-rating',
    [SCREEN.PROFILE_AVATARS]: 'profile-avatars',
    [SCREEN.MANAGE_PROFILE]: 'manage-profile',
    [SCREEN.SEARCH]: 'search',
};

const ROOT_SCREEN_STACK_ROUTES = {
    [SCREEN.COLLECTION]: {
        path: `collection/:title`,
        stringify: {
            title: (title: string) => getUrlFromScreenName(title.toLowerCase()),
        },
    },
    [SCREEN.DETAILS]: {
        path: `details`,
    },
    [SCREEN.DETAILS_VOD_HIGH_USAGE_RESTRICTION]: {
        path: `details/vod-high-usage-restriction`,
    },
    [SCREEN.SETTINGS]: 'settings',
    [SCREEN.LANGUAGE]: 'settings/language',
    [SCREEN.PARENTAL_CONTROL_AND_PIN]: 'settings/parental-control-and-pin',
    [SCREEN.PARENTAL_CONTROL]:
        'settings/parental-control-and-pin/parental-control',
    [SCREEN.AUDIO_AND_SUBTITLES]: 'settings/audio-and-subtitles',
    [SCREEN.SETTINGS_AUDIO]: 'settings/audio-and-subtitles/audio',
    [SCREEN.SETTINGS_SUBTITLES]: 'settings/audio-and-subtitles/subtitles',
    [SCREEN.SETTINGS_SUBTITLES_FONT_SIZE]:
        'settings/audio-and-subtitles/font-size',
    [SCREEN.CHANNELS_LINEUP]: 'settings/channels-lineup',
    [SCREEN.SETTINGS_RECORDING_QUOTA]: 'settings/recording-quota',
    [SCREEN.STANDARD_LIST]: 'settings/standard-list',
    [SCREEN.MY_LIST]: 'settings/my-list',
    [SCREEN.EDIT_MY_LIST]: 'settings/my-list-edit',
    [SCREEN.SWITCH_CHANNEL_LIST]: 'settings/switch-channel-list',
    [SCREEN.ABOUT]: 'settings/about',
    [SCREEN.SETTINGS_HELP]: 'settings/help',
    [SCREEN.SETTINGS_LOGOUT]: 'settings/logout',
    [SCREEN.SETTINGS_BACKEND_INFO]: 'settings/backend-info',
    [SCREEN.SETTINGS_TERMS_CONDITIONS]: 'settings/terms-conditions',
    [SCREEN.SETTINGS_SUBSCRIPTIONS]: 'settings/subscriptions',
};

export const linkingOptions = {
    prefixes: [],
    config: {
        screens: {
            ...defaultConfig,
            [SCREEN.ROOT]: {
                screens: {
                    [SCREEN.HOME]: {
                        path: RootPathnames.home,
                        screens: {
                            [SCREEN.MODULAR_ROOT]: '',
                            ...ROOT_SCREEN_STACK_ROUTES,
                        },
                    },
                    [SCREEN.TV_GUIDE]: {
                        path: RootPathnames.tv,
                        screens: {
                            [SCREEN.EPG]: '',
                            ...ROOT_SCREEN_STACK_ROUTES,
                        },
                    },
                    [SCREEN.RECORDINGS]: {
                        path: RootPathnames.recordings,
                        screens: {
                            [SCREEN.MODULAR_ROOT]: '',
                            ...ROOT_SCREEN_STACK_ROUTES,
                        },
                    },
                    [SCREEN.ON_DEMAND]: {
                        path: RootPathnames.ondemand,
                        screens: {
                            [SCREEN.MODULAR_ROOT]: '',
                            ...ROOT_SCREEN_STACK_ROUTES,
                        },
                    },
                },
            },
            [SCREEN.PIN_SETUP]: {
                path: 'pin-setup',
                screens: {
                    [SCREEN.PIN_SETUP_INTRODUCTION]: 'introduction',
                    [SCREEN.PIN_SETUP_CREATE]: 'create',
                    [SCREEN.PIN_SETUP_SUCCESS]: 'success',
                    [SCREEN.PIN_SETUP_UNSUCCESS]: 'failure',
                },
            },
        },
    },
    getPathFromState(state, config) {
        const BASE_NAME = document.baseURI.replace(
            `${window.location.origin}/`,
            '',
        );
        const nativePath = getPathFromState(state, config);

        return BASE_NAME
            ? `/${BASE_NAME.substr(0, BASE_NAME.length - 1)}${nativePath}`
            : nativePath;
    },
} as LinkingOptions<any>;
